export const initCf7Validation = () => {
	const forms = document.querySelectorAll('.wpcf7 form');

	if (!forms.length) return;

	const PERSON_NAME_PATTERN =
		/^[А-ЯЁа-яёA-Za-z]+(?:[\s'-][А-ЯЁа-яёA-Za-z]+)*$/u;

	const TEXT_PATTERN =
		/^[А-ЯЁа-яёA-Za-z]+(?:[\s'"«»().,/№&+-][А-ЯЁа-яёA-Za-z]+)*$/u;

	const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;

	const VIN_PATTERN = /^[A-HJ-NPR-Z0-9/-]+$/i;

	const messages = {
		required: 'Заполните обязательное поле.',
		personName: 'Введите имя буквами без цифр и специальных символов.',
		text: 'Используйте только буквы и допустимые знаки.',
		phone: 'Введите полный российский номер телефона.',
		email: 'Введите корректный адрес электронной почты.',
		vin: 'VIN должен содержать только латинские буквы и цифры.',
		year: 'Введите корректный год из четырёх цифр.',
		agreement:
			'Необходимо согласиться с политикой обработки персональных данных.',
	};

	const getPhoneDigits = value => {
		return value.replace(/\D/g, '');
	};

	const normalizeRussianPhone = value => {
		let digits = getPhoneDigits(value);

		if (!digits) return '';

		if (digits.startsWith('8')) {
			digits = `7${digits.slice(1)}`;
		} else if (!digits.startsWith('7')) {
			digits = `7${digits}`;
		}

		return digits.slice(0, 11);
	};

	const formatRussianPhone = value => {
		const digits = normalizeRussianPhone(value);

		if (!digits) return '';

		const code = digits.slice(1, 4);
		const firstPart = digits.slice(4, 7);
		const secondPart = digits.slice(7, 9);
		const thirdPart = digits.slice(9, 11);

		let result = '+7';

		if (code) {
			result += ` (${code}`;
		}

		if (code.length === 3) {
			result += ')';
		}

		if (firstPart) {
			result += ` ${firstPart}`;
		}

		if (secondPart) {
			result += `-${secondPart}`;
		}

		if (thirdPart) {
			result += `-${thirdPart}`;
		}

		return result;
	};

	const isValidRussianPhone = value => {
		const digits = normalizeRussianPhone(value);

		return /^7[3489]\d{9}$/.test(digits);
	};

	const getFieldWrapper = field => {
		return field.closest('.wpcf7-form-control-wrap');
	};

	const removeCustomError = field => {
		field.classList.remove('wpcf7-not-valid');
		field.removeAttribute('aria-invalid');

		const wrapper = getFieldWrapper(field);

		wrapper
			?.querySelectorAll('.js-validation-error')
			.forEach(error => error.remove());
	};

	const showCustomError = (field, message) => {
		removeCustomError(field);

		field.classList.add('wpcf7-not-valid');
		field.setAttribute('aria-invalid', 'true');

		const wrapper = getFieldWrapper(field);

		if (!wrapper) return;

		const error = document.createElement('span');

		error.className = 'wpcf7-not-valid-tip js-validation-error';
		error.setAttribute('aria-hidden', 'true');
		error.textContent = message;

		wrapper.append(error);
	};

	const validatePersonName = field => {
		const value = field.value.trim();

		if (field.required && !value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!value) {
			removeCustomError(field);
			return true;
		}

		if (value.length < 2 || !PERSON_NAME_PATTERN.test(value)) {
			showCustomError(field, messages.personName);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validateTextField = field => {
		const value = field.value.trim();

		if (field.required && !value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!value) {
			removeCustomError(field);
			return true;
		}

		if (!TEXT_PATTERN.test(value)) {
			showCustomError(field, messages.text);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validatePhone = field => {
		const value = field.value.trim();

		if (!value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!isValidRussianPhone(value)) {
			showCustomError(field, messages.phone);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validateEmail = field => {
		const value = field.value.trim();

		if (!value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!EMAIL_PATTERN.test(value)) {
			showCustomError(field, messages.email);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validateVin = field => {
		const value = field.value.trim();

		if (field.required && !value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!value) {
			removeCustomError(field);
			return true;
		}

		if (!VIN_PATTERN.test(value)) {
			showCustomError(field, messages.vin);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validateYear = field => {
		const value = field.value.trim();

		if (field.required && !value) {
			showCustomError(field, messages.required);
			return false;
		}

		if (!value) {
			removeCustomError(field);
			return true;
		}

		const year = Number(value);
		const currentYear = new Date().getFullYear();

		if (
			!/^\d{4}$/.test(value) ||
			year < 1900 ||
			year > currentYear + 1
		) {
			showCustomError(field, messages.year);
			return false;
		}

		removeCustomError(field);
		return true;
	};

	const validateRequiredSelect = field => {
		if (field.value.trim()) {
			removeCustomError(field);
			return true;
		}

		showCustomError(field, messages.required);
		return false;
	};

	const validateRequiredFile = field => {
		if (field.files?.length) {
			removeCustomError(field);
			return true;
		}

		showCustomError(field, messages.required);
		return false;
	};

	const validateAgreement = field => {
		if (field.checked) {
			removeCustomError(field);
			return true;
		}

		showCustomError(field, messages.agreement);
		return false;
	};

	const clearFormErrors = form => {
		form.querySelectorAll('.js-validation-error').forEach(error => {
			error.remove();
		});

		form.querySelectorAll('.wpcf7-not-valid').forEach(field => {
			field.classList.remove('wpcf7-not-valid');
			field.removeAttribute('aria-invalid');
		});
	};

	forms.forEach(form => {
		const personNameFields = form.querySelectorAll('.js-person-name');
		const textOnlyFields = form.querySelectorAll('.js-text-only');
		const freeTextFields = form.querySelectorAll('.js-free-text');
		const phoneFields = form.querySelectorAll('.js-phone-mask');
		const emailFields = form.querySelectorAll('.js-email');
		const vinFields = form.querySelectorAll('.js-vin');
		const yearFields = form.querySelectorAll('.js-year');

		personNameFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value
					.replace(/[^А-ЯЁа-яёA-Za-z\s'-]/gu, '')
					.replace(/\s{2,}/g, ' ')
					.replace(/-{2,}/g, '-')
					.replace(/'{2,}/g, "'");

				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				validatePersonName(field);
			});
		});

		textOnlyFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value
					.replace(
						/[^А-ЯЁа-яёA-Za-z\s'"«»().,/№&+-]/gu,
						''
					)
					.replace(/\s{2,}/g, ' ');

				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				validateTextField(field);
			});
		});

		freeTextFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value
					.replace(/<[^>]*>/g, '')
					.replace(
						/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g,
						''
					);

				removeCustomError(field);
			});
		});

		phoneFields.forEach(field => {
			field.addEventListener('focus', () => {
				if (!field.value) {
					field.value = '+7';
				}
			});

			field.addEventListener('input', () => {
				field.value = formatRussianPhone(field.value);
				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				if (field.value === '+7') {
					field.value = '';
				}

				validatePhone(field);
			});

			field.addEventListener('paste', event => {
				event.preventDefault();

				const pastedValue =
					event.clipboardData?.getData('text') ?? '';

				field.value = formatRussianPhone(pastedValue);

				removeCustomError(field);
			});
		});

		emailFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value.replace(/\s/g, '');
				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				validateEmail(field);
			});
		});

		vinFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value
					.toUpperCase()
					.replace(/[^A-HJ-NPR-Z0-9/-]/g, '');

				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				validateVin(field);
			});
		});

		yearFields.forEach(field => {
			field.addEventListener('input', () => {
				field.value = field.value
					.replace(/\D/g, '')
					.slice(0, 4);

				removeCustomError(field);
			});

			field.addEventListener('blur', () => {
				validateYear(field);
			});
		});

		form.querySelectorAll('select[required]').forEach(field => {
			field.addEventListener('change', () => {
				validateRequiredSelect(field);
			});
		});

		form.querySelectorAll('input[type="file"][required]').forEach(field => {
			field.addEventListener('change', () => {
				validateRequiredFile(field);
			});
		});

		form
			.querySelectorAll(
				'.wpcf7-acceptance input[type="checkbox"]'
			)
			.forEach(field => {
				field.addEventListener('change', () => {
					validateAgreement(field);
				});
			});

		form.addEventListener(
			'submit',
			event => {
				const results = [];

				personNameFields.forEach(field => {
					results.push(validatePersonName(field));
				});

				textOnlyFields.forEach(field => {
					results.push(validateTextField(field));
				});

				phoneFields.forEach(field => {
					results.push(validatePhone(field));
				});

				emailFields.forEach(field => {
					results.push(validateEmail(field));
				});

				vinFields.forEach(field => {
					results.push(validateVin(field));
				});

				yearFields.forEach(field => {
					results.push(validateYear(field));
				});

				form.querySelectorAll('select[required]').forEach(field => {
					results.push(validateRequiredSelect(field));
				});

				form
					.querySelectorAll('input[type="file"][required]')
					.forEach(field => {
						results.push(validateRequiredFile(field));
					});

				form
					.querySelectorAll(
						'.wpcf7-acceptance input[type="checkbox"]'
					)
					.forEach(field => {
						results.push(validateAgreement(field));
					});

				const isValid = results.every(Boolean);

				if (isValid) return;

				event.preventDefault();
				event.stopImmediatePropagation();

				const firstInvalidField =
					form.querySelector('.wpcf7-not-valid');

				firstInvalidField?.focus({
					preventScroll: true,
				});

				firstInvalidField?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			},
			true
		);

		form.addEventListener('reset', () => {
			clearFormErrors(form);
		});
	});

	document.addEventListener('wpcf7mailsent', event => {
		const form = event.target.querySelector('form');

		if (form) {
			clearFormErrors(form);
		}
	});
};